import Http from "@/commons/Http";

const path = 'api/protocol-annotation';

export default {

    async getAll(protocolId = ''){
        return Http.get(`${path}/all/${protocolId}`);
    },

    async save(annotation, protocolId = ''){
        return Http.post(`${path}/${protocolId}`, {annotation});
    },

    async edit(annotation, protocolAnnotationId = ''){
        return Http.put(`${path}/${protocolAnnotationId}`, {annotation});
    },

    async delete(protocolAnnotationId ){
        return Http.delete(`${path}/${protocolAnnotationId}`);
    },

}
